// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/common/jquery-3.6.0.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_1___ = new URL("/common/jquery.query.js", import.meta.url);
var ___HTML_LOADER_IMPORT_2___ = new URL("/common/jquery.json.min.js", import.meta.url);
var ___HTML_LOADER_IMPORT_3___ = new URL("/common/default.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_4___ = new URL("../../common.js", import.meta.url);
var ___HTML_LOADER_IMPORT_5___ = new URL("../index.js", import.meta.url);
var ___HTML_LOADER_IMPORT_6___ = new URL("../index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_7___ = new URL("../../index.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_8___ = new URL("/common/timer.js", import.meta.url);
var ___HTML_LOADER_IMPORT_9___ = new URL("/common/header.js", import.meta.url);
var ___HTML_LOADER_IMPORT_10___ = new URL("/component/two-word/const.js", import.meta.url);
var ___HTML_LOADER_IMPORT_11___ = new URL("/component/two-word/two-word.js", import.meta.url);
var ___HTML_LOADER_IMPORT_12___ = new URL("/common/header.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_13___ = new URL("/component/two-word/submenu.js", import.meta.url);
var ___HTML_LOADER_IMPORT_14___ = new URL("/component/two-word/two-word.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_15___ = new URL("/common/menu_li.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_16___ = new URL("/component/two-word/guidemenu.js", import.meta.url);
var ___HTML_LOADER_IMPORT_17___ = new URL("/component/two-word/two-word_results.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_18___ = new URL("/common/sitepolicy.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_19___ = new URL("/component/infoarea.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_20___ = new URL("/fortune/common/tarot-shuffle.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_21___ = new URL("/fortune/common/tarot-shuffle.js", import.meta.url);
var ___HTML_LOADER_IMPORT_22___ = new URL("/fortune/common/marquee.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_23___ = new URL("/fortune/common/button.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_24___ = new URL("/fortune/common/horoscope.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_25___ = new URL("/fortune/common/breadcrumbs.scss", import.meta.url);
var ___HTML_LOADER_IMPORT_26___ = new URL("/common/footer.scss", import.meta.url);
// Module
var code = `<!DOCTYPE html>
<html lang="ja">
  <head
    prefix="og: http://ogp.me/ns# fb: http://ogp.me/ns/ fb# article: http://ogp.me/ns/article#"
  >
    <!-- prettier-ignore -->
    
    <!---->
    <!--デフォルト値の設定-->




<meta charset="UTF-8" />
<meta
  name="viewport"
  content="width=device-width,user-scalable=no,initial-scale=1,maximum-scale=1"
/>
<meta name="format-detection" content="telephone=no" />
<title>タロット占い 〈テーマ〉運命の人とはもう出会っている?｜星座＆タロット占い｜【Ponta】お金のミカタ</title>
<meta name="description" content="知りたいテーマを選んでタロット占い！お金・仕事・恋愛・家庭・結婚の5つのカテゴリから、あなたの運勢を占ってみましょう。" />
<link rel="index" href="index.htm" />
<!-- icon -->
<link
  rel="shortcut icon"
  type="image/vnd.microsoft.icon"
  href="/cmn/img/favicon.ico"
/>
<link rel="icon" type="image/x-icon" href="/cmn/img/favicon.ico" />
<link
  rel="apple-touch-icon"
  sizes="180x180"
  href="/cmn/img/apple-touch-icon.png"
/>
<!-- og -->
<meta property="og:url" content="https://www.finance.ponta.jp/fortune/tarot/theme12/" />
<meta property="og:type" content="website" />
<meta property="og:title" content="タロット占い 〈テーマ〉運命の人とはもう出会っている?｜星座＆タロット占い｜【Ponta】お金のミカタ" />
<meta property="og:description" content="知りたいテーマを選んでタロット占い！お金・仕事・恋愛・家庭・結婚の5つのカテゴリから、あなたの運勢を占ってみましょう。" />
<meta property="og:site_name" content="【Ponta】お金のミカタ" />
<meta property="og:image" content="https://www.finance.ponta.jp/fortune/images/ogp.jpg" />
<!-- Twitter -->
<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:site" content="@Ponta" />

${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_0___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_1___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_2___}">${"<" + "/script"}>

<!-- StyleSheet -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_3___}" />

<!-- noto sans jp の読み込み -->
<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  rel="preload"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  as="style"
/>
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap"
  media="print"
  onload="this.media = 'all'"
/>

<!-- corporate-logo の読み込み -->
<link rel="preload" href="/font/corporate-logo.css" as="style" />
<link
  rel="stylesheet"
  href="/font/corporate-logo.css"
  media="print"
  onload="this.media = 'all'"
/>

<!-- Google Tag Manager (loadイベント後に遅延読み込み) -->
<!-- 旧コード: Clarityとアニメーションの競合解消後に戻す
${"<" + "script"}>
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-P3QVP6P");
${"<" + "/script"}>
-->
${"<" + "script"}>
  window.dataLayer = window.dataLayer || [];
  window.addEventListener("load", function () {
    dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = document.getElementsByTagName("script")[0],
      j = document.createElement("script");
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=GTM-P3QVP6P";
    f.parentNode.insertBefore(j, f);
  });
${"<" + "/script"}>

<!-- Google広告 -->
${"<" + "script"}
  async
  src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
  crossorigin="anonymous"
>${"<" + "/script"}>

    ${"<" + "script"}
      type="text/javascript"
      src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js"
    >${"<" + "/script"}>
    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_4___}">${"<" + "/script"}>
    ${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_5___}">${"<" + "/script"}>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_6___}" />
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_7___}" />

    <!-- 検索避け -->
    <meta name="robots" content="noindex,nofollow" />
  </head>

  <body>
    <!-- Google Tag Manager (noscript) -->
<noscript
  ><iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-P3QVP6P"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>
<!-- End Google Tag Manager (noscript) -->
 <link
  rel="stylesheet"
  href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css"
/>
${"<" + "script"} src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js">${"<" + "/script"}>
<!--タイマー読み込み-->
${"<" + "script"} src="${___HTML_LOADER_IMPORT_8___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_9___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_10___}">${"<" + "/script"}>
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_11___}">${"<" + "/script"}>
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_12___}" />

<header>
  <nav id="header-inner">
    <a id="ponta-logo" data-id="header-mikata_Ponta-logo" href="/">
      <img
        src="/cmn/img/logo_okaneponta.svg"
        alt="Ponta"
        width="59"
        height="13"
      />
    </a>
    <ul class="global-menu">
      <li class="tab-list-item mikata active_tab">
        <h1 id="site-title">
          <a href="/" data-id="header-mikata_tabmenu_mikata">お金のミカタ</a>
        </h1>
      </li>
      <li class="tab-list-item column">
        <a
          href="https://column.finance.ponta.jp/"
          data-id="header-mikata_tabmenu_column"
          >ミカタイムズ</a
        >
      </li>
    </ul>
  </nav>
  <nav id="sub_menu">
    <div class="sub-list-wrapper">
      <ul class="sub-list">
        <li class="sub-list-item">
          <a href="/mottainai/" data-id="hamburger_mottainai">もったいない</a>
        </li>
        <li class="sub-list-item">
          <a href="/money-ponkatsu/" data-id="hamburger_money-ponkatsu"
            >マネPon</a
          >
        </li>
        <li class="sub-list-item">
          <a href="/fortune/" data-id="hamburger_fortune">金運</a>
        </li>
        <li class="sub-list-item">
          <a href="/money/" data-id="hamburger_ponta-finance">銀行証券</a>
        </li>
        <li class="sub-list-item">
          <a href="/insurance/" data-id="hamburger_hoken">保険</a>
        </li>
      </ul>
    </div>
    <div class="sub-menu-two-words">
      
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_13___}">${"<" + "/script"}>
  

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_14___}" />

<div id="sub-menu_two-words">
  <div id="sub-menu_first_word__dropdown" class="dropdown">
    <div
      id="sub-menu_first_word__toggle"
      class="first_word__toggle dropdown__toggle"
    >
      <span>➀ やりたいこと</span>
    </div>
    <div id="sub-menu_first_word__menu-base" class="menu-base">
      <ul
        id="sub-menu_first_word__menu"
        class="dropdown__menu first_word__menu"
        data-id="header-mikata_navimenu_search1"
      >
        <li class="option disabled">① やりたいことを選択 ▼</li>
      </ul>
    </div>
  </div>
  <div id="sub-menu_second_word__dropdown" class="dropdown">
    <div id="sub-menu_second_word__toggle" class="dropdown__toggle">
      <span>➁ どうやって？</span>
    </div>
    <div id="sub-menu_second_word__menu-base" class="menu-base">
      <ul
        id="sub-menu_second_word__menu"
        class="dropdown__menu second_word__menu"
        data-id="header-mikata_navimenu_search2"
      >
        <li class="option disabled">➁ どうやって？ ▼</li>
      </ul>
    </div>
  </div>
</div>

    </div>
    <div class="guide-menu-container">
      <input
        id="drawer_input"
        class="drawer_hidden"
        type="checkbox"
        data-id="header-mikata_openmenu"
      />
      <label for="drawer_input" class="guide-menu-open">
        <img src="/cmn/img/hamburger.svg" width="28.5" height="18" />
        <span>MENU</span>
      </label>
      <div id="guide-menu">
        <div class="guide-menu-wrapper">
          <div class="guide-menu-header">
            <div class="guide-menu-title">
              <a href="/">
                <img
                  src="/cmn/img/logo_menu-mikata.svg"
                  alt="Ponta お金のミカタ"
                  　width="260"
                  height="27"
                />
              </a>
            </div>
            <label for="drawer_input" class="guide-menu-close">
              <img src="/cmn/img/close.svg" />
              <span>CLOSE</span>
            </label>
          </div>
          <ul class="category_list">
            <!-- prettier-ignore -->
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/mottainai/"
    data-id="hamburger_mottainai"
    target=""
    rel=""
  >
    知らないなんてもったいない！
  </a>
  
  <input
    id="drawer-ponta_10"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_10" class="drawer_open">
    <span id="drawer_span_10">＋</span>
  </label>
  <ul id="menu2_10" class="menu2">
    
    <li>
      <a
        href="/mottainai/type/"
        data-id="hamburger_mottainai_type"
        target=""
        rel=""
        >もったいない診断</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/mufg/"
        data-id="hamburger_mottainai_mufg"
        target=""
        rel=""
        >三菱UFJ銀行</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/lawsonbank/atm/"
        data-id="hamburger_mottainai_lawsonbank_atm"
        target=""
        rel=""
        >ぽんたまATM</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/lawsonbank/credit/"
        data-id="hamburger_mottainai_lawsonbank_credit"
        target=""
        rel=""
        >ローソンPontaプラス</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/connect-sec/"
        data-id="hamburger_mottainai_connect-sec"
        target=""
        rel=""
        >大和コネクト証券</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/insurance/fp/"
        data-id="hamburger_mottainai_insurance_fp"
        target=""
        rel=""
        >ライフプラン表作成サービス</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/game/"
        data-id="hamburger_mottainai_game"
        target=""
        rel=""
        >金融ゲーム</a
      >
    </li>
    
    <li>
      <a
        href="/mottainai/rental-subsc/"
        data-id="hamburger_mottainai_rental-subsc"
        target=""
        rel=""
        >家電レンタルサービス（アリスプライム）</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/money-ponkatsu/?from=hamburger_money-ponkatsu"
    data-id="hamburger_money-ponkatsu"
    target=""
    rel=""
  >
    マネPon（楽しみながらためる）
  </a>
  
  <input
    id="drawer-ponta_1"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_1" class="drawer_open">
    <span id="drawer_span_1">＋</span>
  </label>
  <ul id="menu2_1" class="menu2">
    
    <li>
      <a
        href="/2-choices/"
        data-id="hamburger_2-choices"
        target=""
        rel=""
        >2択でPonta</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/money/"
    data-id="hamburger_ponta-finance"
    target=""
    rel=""
  >
    Pontaファイナンス
  </a>
  
  <input
    id="drawer-ponta_2"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_2" class="drawer_open">
    <span id="drawer_span_2">＋</span>
  </label>
  <ul id="menu2_2" class="menu2">
    
    <li>
      <a
        href="/money/#saving_point"
        data-id="hamburger_ponta-finance_saving_point"
        target=""
        rel=""
        >金融機関でポイントをためる</a
      >
    </li>
    
    <li>
      <a
        href="/money/#invest-trial_point"
        data-id="hamburger_ponta-finance_invest-trial_point"
        target=""
        rel=""
        >投資体験でポイントを増やす</a
      >
    </li>
    
    <li>
      <a
        href="/money/#invest_point"
        data-id="hamburger_ponta-finance_invest_point"
        target=""
        rel=""
        >ポイントをつかってリアル投資</a
      >
    </li>
    
  </ul>
  
</li>

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/insurance/"
    data-id="hamburger_hoken"
    target=""
    rel=""
  >
    Pontaの保険
  </a>
  
  <input
    id="drawer-ponta_3"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_3" class="drawer_open">
    <span id="drawer_span_3">＋</span>
  </label>
  <ul id="menu2_3" class="menu2">
    
    <li>
      <a
        href="/insurance/#insurance-easy"
        data-id="hamburger_hoken_kantan"
        target=""
        rel=""
        >1日から入れる保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-hokepon"
        data-id="hamburger_hoken_hokepon"
        target=""
        rel=""
        >Ponta会員限定保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-au-seimei"
        data-id="hamburger_hoken_au-seimei"
        target=""
        rel=""
        >ポイントがたまる生命保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-living"
        data-id="hamburger_hoken_living"
        target=""
        rel=""
        >暮らしの保険</a
      >
    </li>
    
    <li>
      <a
        href="/insurance/#insurance-pet"
        data-id="hamburger_hoken_pet"
        target=""
        rel=""
        >わんにゃん保険</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/lifeplan/"
    data-id="hamburger_lifeplan"
    target=""
    rel=""
  >
    ライフプラン表作成サービス
  </a>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/diagnosis/"
    data-id="hamburger_400f"
    target=""
    rel=""
  >
    お金の相談窓口（オカネコ）
  </a>
  
</li>

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/fortune/"
    data-id="hamburger_fortune"
    target=""
    rel=""
  >
    星座＆タロット占い
  </a>
  
  <input
    id="drawer-ponta_6"
    class="drawer_input_category drawer_hidden"
    type="checkbox"
    onchange="toggleValue(this)"
  />
  <label for="drawer-ponta_6" class="drawer_open">
    <span id="drawer_span_6">＋</span>
  </label>
  <ul id="menu2_6" class="menu2">
    
    <li>
      <a
        href="/fortune/#horoscope-rank"
        data-id="hamburger_fortune_horoscope"
        target=""
        rel=""
        >今日の金運ランキング</a
      >
    </li>
    
    <li>
      <a
        href="/fortune/tarot/"
        data-id="hamburger_fortune_tarot"
        target=""
        rel=""
        >タロット占い</a
      >
    </li>
    
  </ul>
  
</li>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_15___}" />
<li>
  <a
    class="category_title"
    href="/campaign/"
    data-id="hamburger_campaign-list"
    target=""
    rel=""
  >
    キャンペーン一覧
  </a>
  
</li>

          </ul>
          <div class="guide-menu_two-words_container">
            <p>二言で検索</p>
             
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_16___}">${"<" + "/script"}>
 

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_14___}" />

<div id="guide-menu_two-words">
  <div id="guide-menu_first_word__dropdown" class="dropdown">
    <div
      id="guide-menu_first_word__toggle"
      class="first_word__toggle dropdown__toggle"
    >
      <span>➀ やりたいこと</span>
    </div>
    <div id="guide-menu_first_word__menu-base" class="menu-base">
      <ul
        id="guide-menu_first_word__menu"
        class="dropdown__menu first_word__menu"
        data-id="header-mikata_navimenu_search1"
      >
        <li class="option disabled">① やりたいことを選択 ▼</li>
      </ul>
    </div>
  </div>
  <div id="guide-menu_second_word__dropdown" class="dropdown">
    <div id="guide-menu_second_word__toggle" class="dropdown__toggle">
      <span>➁ どうやって？</span>
    </div>
    <div id="guide-menu_second_word__menu-base" class="menu-base">
      <ul
        id="guide-menu_second_word__menu"
        class="dropdown__menu second_word__menu"
        data-id="header-mikata_navimenu_search2"
      >
        <li class="option disabled">➁ どうやって？ ▼</li>
      </ul>
    </div>
  </div>
</div>

            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_17___}" />
<div
  id="guide-menu_search_results"
  class="search_results_guide-menu search_results"
>
  <div class="swiper guide-menu_search_results_swiper">
    <ul id="guide-menu_search_results_ul" class="swiper-wrapper">
      <li id="search_result_container" class="swiper-slide">
        <div class="search_result_container">
          <a class="link" href="/">
            <img class="ogp_image" src="/cmn/img/ogp_image_sample.svg" />
            <p class="title">タイトル</p>
          </a>
        </div>
      </li>
    </ul>
    <div class="guide-menu_swiper-scrollbar swiper-scrollbar"></div>
  </div>
  <div
    id="non-exist_search_results_guide-menu"
    class="non-exist_search_results"
  >
    <p>検索結果がありません。</p>
  </div>
  <div class="close_search_results_container">
    <a class="close_search_results" onclick="closeResults('guide-menu')">
      検索結果を閉じる ✕
    </a>
  </div>
</div>

          </div>
          <div class="guide-menu_sitepolicy_container">
            <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_18___}" />
<ul class="sitepolicy-link">
  <li>
    <a href="/about/#insurance_inquiry" data-id="guide-menu_inquiry"
      >お問い合わせ一覧</a
    >
  </li>
  <li>
    <a
      href="/about/solicitation_policy/"
      data-id="guide-menu_solicitation-policy"
      >代理店勧誘方針について</a
    >
  </li>
  <li>
    <a href="/about/" data-id="guide-menu_site-guide"
      >お金のミカタについて</a
    >
  </li>
  <li>
    <a href="/about/sitemap/" data-id="guide-menu_sitemap"
      >サイトマップ</a
    >
  </li>
</ul>

          </div>
        </div>
      </div>
    </div>
  </nav>
  <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_17___}" />
<div
  id="sub-menu_search_results"
  class="search_results_sub-menu search_results"
>
  <div class="swiper sub-menu_search_results_swiper">
    <ul id="sub-menu_search_results_ul" class="swiper-wrapper">
      <li id="search_result_container" class="swiper-slide">
        <div class="search_result_container">
          <a class="link" href="/">
            <img class="ogp_image" src="/cmn/img/ogp_image_sample.svg" />
            <p class="title">タイトル</p>
          </a>
        </div>
      </li>
    </ul>
    <div class="sub-menu_swiper-scrollbar swiper-scrollbar"></div>
  </div>
  <div
    id="non-exist_search_results_sub-menu"
    class="non-exist_search_results"
  >
    <p>検索結果がありません。</p>
  </div>
  <div class="close_search_results_container">
    <a class="close_search_results" onclick="closeResults('sub-menu')">
      検索結果を閉じる ✕
    </a>
  </div>
</div>

</header>
<!-- お知らせエリア（通常は非表示） -->
<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_19___}" />

<dl id="info-top" class="red">
  <dt><span>重要なお知らせ</span></dt>
  <dd>
    <!--<b>10月22日</b>-->　
    現在、お金のミカタ内の一部サービスにおいて、セキュリティ対応等のためメンテナンスを実施しております。メンテナンス期間中は、対象となる一部サービスをご利用いただけない場合がございます。ご利用のお客様にはご不便をおかけし、申し訳ございません。ご理解いただきますよう、お願い申し上げます。
  </dd>
</dl>

<!--
<dl id="info-top">
    <dt><span>お知らせ</span></dt>
    <dd>
        <a href="https://www.finance.ponta.jp/campaign/risoku20220329/?from=info_risoku">＼Pontaポイント利息で増えるキャンペーン実施中／</a>
    </dd>
</dl>
-->


    <div class="body-contents">
      <main>
        <!--Google広告ここから-->
        <div class="google-ads">
          ${"<" + "script"}
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2528660706528280"
            crossorigin="anonymous"
          >${"<" + "/script"}>
          <!-- 占い_タロットヘッダ_固定_320×100 -->
          <ins
            class="adsbygoogle"
            style="display: inline-block; width: 320px; height: 100px"
            data-ad-client="ca-pub-2528660706528280"
            data-ad-slot="8867038243"
          ></ins>
          ${"<" + "script"}>
            (adsbygoogle = window.adsbygoogle || []).push({});
          ${"<" + "/script"}>
        </div>
        <!--Google広告ここまで-->
        <div class="bg-white">
          <!-- シャッフル -->
          <h2 class="theme-head">
            運命の人とは<br class="u-sp" />もう出会っている？
          </h2>
          <div id="page-shuffle" style="opacity: 0">
            <div class="theme">
              <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_20___}" />
${"<" + "script"} type="text/javascript" src="${___HTML_LOADER_IMPORT_21___}">${"<" + "/script"}>

<div class="tarot-shuffle" data-js="tarot-container">
  <div class="tarot-shuffle-txt" data-js="tarot-text" style="opacity: 0">
    カードを1枚選んでください
  </div>
  <div class="tarot-shuffle-cards" data-js="tarot-content" style="opacity: 0">
    <div class="tarot-shuffle-card">
      <!-- Add classes by js: .is-enabled, .is-flipped -->
      <a href="/fortune/tarot/theme1/?r=1" data-js="tarot-link">
        <img
          class="tarot-shuffle-card-back"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-choice"
          alt=""
        />
        <!-- Update src by js: /fortune/images/tarot-card_##.png -->
        <img
          class="tarot-shuffle-card-front"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-front"
          alt=""
        />
      </a>
    </div>
    <div class="tarot-shuffle-card">
      <a href="/fortune/tarot/theme1/?r=1" data-js="tarot-link">
        <img
          class="tarot-shuffle-card-back"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-choice"
          alt=""
        />
        <img
          class="tarot-shuffle-card-front"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-front"
          alt=""
        />
      </a>
    </div>
    <div class="tarot-shuffle-card">
      <a href="/fortune/tarot/theme1/?r=1" data-js="tarot-link">
        <img
          class="tarot-shuffle-card-back"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-choice"
          alt=""
        />
        <img
          class="tarot-shuffle-card-front"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-front"
          alt=""
        />
      </a>
    </div>
    <div class="tarot-shuffle-card">
      <a href="/fortune/tarot/theme1/?r=1" data-js="tarot-link">
        <img
          class="tarot-shuffle-card-back"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-choice"
          alt=""
        />
        <img
          class="tarot-shuffle-card-front"
          src="/fortune/images/tarot-card.png"
          width="125"
          height="214"
          data-js="tarot-front"
          alt=""
        />
      </a>
    </div>
  </div>
  <div
    class="tarot-shuffle-dummy-cards"
    data-js="tarot-dummy-content"
    style="opacity: 0"
  >
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
  </div>
  <div
    class="tarot-shuffle-dummy-cards"
    data-js="tarot-dummy-content"
    style="opacity: 0"
  >
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
  </div>
  <div
    class="tarot-shuffle-dummy-cards"
    data-js="tarot-dummy-content"
    style="opacity: 0"
  >
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
    <img
      src="/fortune/images/tarot-card.png"
      width="125"
      height="214"
      data-js="tarot-dummy"
      alt=""
    />
  </div>
</div>
 <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_22___}" />
<div class="mv-marquee">
  <figure class="mv-marquee-inner">
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
  </figure>
</div>

              <div class="theme-btn">
                <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_23___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn white ">
  <a class="u-hover" data-id="tarot-result_back_top" href="/fortune/?from=tarot-result_back_top">
    <span>
      
      <img src="/fortune/images/arrow-link-black.png" width="26" height="9" alt="" />
      
    </span>
    占いTOPへ戻る
    <span>
       
    </span>
  </a>
</div>

              </div>
            </div>
          </div>
          <!-- 結果 -->
          <div id="page-result" style="opacity: 0">
            <div class="theme">
              <div class="theme-result">
  <div class="theme-result-card">
    <div class="theme-result-card-marquee">
      <figure class="theme-result-card-marquee-inner">
        <img
          src="/fortune/images/tarot-reading-door-marquee.png"
          width="824"
          height="78"
          alt=""
        />
        <img
          src="/fortune/images/tarot-reading-door-marquee.png"
          width="824"
          height="78"
          alt=""
        />
        <img
          src="/fortune/images/tarot-reading-door-marquee.png"
          width="824"
          height="78"
          alt=""
        />
        <img
          src="/fortune/images/tarot-reading-door-marquee.png"
          width="824"
          height="78"
          alt=""
        />
      </figure>
    </div>
    <div
      class="theme-result-card-img"
      data-js="tarot-theme-content"
      style="opacity: 0"
    >
      <img data-js="tarot-theme-card" width="287" height="491" alt="" />
    </div>
    <div
      class="theme-result-card-txt"
      data-js="tarot-theme-content"
      style="opacity: 0"
    >
      <span data-js="tarot-theme-card-name">　</span>
    </div>
  </div>
  <div class="theme-result-detail">
    <div
      class="theme-result-detail-ttl"
      data-js="tarot-theme-content"
      style="opacity: 0"
    >
      <span data-js="tarot-theme-summary"></span>
    </div>
    <p
      class="theme-result-detail-txt"
      data-js="tarot-theme-content"
      style="opacity: 0"
    >
      <span data-js="tarot-theme-text"></span>
    </p>
    <div class="theme-result-detail-socical">
      <a
        data-id="tarot-result_sns_line"
        href="https://social-plugins.line.me/lineit/share?from=tarot-result_sns_line&url=https://www.finance.ponta.jp/fortune/tarot/"
        target="_blank"
        class="u-hover"
        data-js="tarot-theme-share-link"
      >
        <img src="/fortune/images/ic-line.png" alt="Line" />
      </a>
      <a
        data-id="tarot-result_sns_facebook"
        href="https://www.facebook.com/share.php?u=https://www.finance.ponta.jp/fortune/tarot/"
        target="_blank"
        class="u-hover"
        data-js="tarot-theme-share-link"
      >
        <img src="/fortune/images/ic-fb.png" alt="Facebook" />
      </a>
      <a
        data-id="tarot-result_sns_x"
        href="https://twitter.com/intent/tweet?from=tarot-result_sns_x&url=https://www.finance.ponta.jp/fortune/tarot/"
        target="_blank"
        class="u-hover"
        data-js="tarot-theme-share-link"
      >
        <img src="/fortune/images/ic-x.png" alt="X" />
      </a>
    </div>
    <div class="theme-result-detail-btns">
      <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_23___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn black ">
  <a class="u-hover" data-id="tarot-result_retry" href="?from=tarot-result_retry">
    <span>
      
    </span>
    もう一度占う
    <span>
      
      <img src="/fortune/images/arrow-link-white.png" width="26" height="9" alt="" />
       
    </span>
  </a>
</div>
 <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_23___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn transparent ">
  <a class="u-hover" data-id="tarot-result_back_theme" href="/fortune/tarot/?from=tarot-result_back_theme#tarot-category">
    <span>
      
    </span>
    別のテーマを選ぶ
    <span>
       
      <img src="/fortune/images/arrow-link-black.png" width="26" height="9" alt="" />
      
    </span>
  </a>
</div>

    </div>
  </div>
</div>
 <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_22___}" />
<div class="mv-marquee">
  <figure class="mv-marquee-inner">
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
    <img
      src="/fortune/images/fortune-mv-marquee.png"
      width="934"
      height="85"
      alt="TODAY’S FORTUNE"
    />
  </figure>
</div>

              <!-- <link rel="stylesheet" href="/fortune/common/recommend.scss" />

<div class="recommend">
  <div class="recommend-ttl">
    <h4><img src="/fortune/images/recommend-title.png" width="648" height="46" alt="あなたへのおすすめ" /></h4>
  </div>
  <div class="recommend-articles">
    
      <a class="recommend-article u-hover" data-id="tarot-result_theme12_banner1" href="https://www.finance.ponta.jp/money/mufg/?utm_source=mikata&amp;utm_medium=banner&amp;utm_campaign=mikata_ponkatsu-carousel_mufg230920&from=tarot-result_theme12_banner1" target="">
        <img src="/fortune/images/recommend/banner2_mufg_800‐300.png" alt="MUFG（えーそうなの？）" />
      </a>
    
      <a class="recommend-article u-hover" data-id="tarot-result_theme12_banner2" href="https://www.finance.ponta.jp/diagnosis/?utm_source=mikata&amp;utm_medium=banner&amp;utm_campaign=mikata_tarot-carousel_shorai_banner230920&from=tarot-result_theme12_banner2" target="">
        <img src="/fortune/images/recommend/03_800x300_b_02.jpg" alt="オカネコチャットバナー（将来への不安）" />
      </a>
    
  </div>
</div>
  -->
              <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_24___}" />

<div class="horoscope-constellation">
  <div class="horoscope-constellation-inner">
    <h2 class="fortune-horoscope-ttl">
      <img
        class="u-pc"
        src="/fortune/images/fortune-ttl-horoscope.png"
        alt="[星座占い] Horoscope"
      />
      <img
        class="u-sp"
        src="/fortune/images/fortune-ttl-horoscope-sp.png"
        alt="[星座占い] Horoscope"
      />
    </h2>
    <p class="fortune-horoscope-txt">
      今日の金運をチェック！<br />
      あなたのミカタになるアイテムや、<br
        class="u-sp"
      />Pontaからのアドバイスもお見逃しなく♪
    </p>
    <!-- prettier-ignore -->
    <div class="horoscope-btn"><link rel="stylesheet" href="${___HTML_LOADER_IMPORT_23___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn black ">
  <a class="u-hover" data-id="tarot-result_jump_horoscope-list" href="/fortune/?from=tarot-result_jump_horoscope-list#horoscope-list">
    <span>
      
    </span>
    星座の一覧を見る
    <span>
      
      <img src="/fortune/images/arrow-link-white.png" width="26" height="9" alt="" />
       
    </span>
  </a>
</div>
</div>
  </div>
</div>
<!-- prettier-ignore -->
<div class="horoscope-constellation-btn"><link rel="stylesheet" href="${___HTML_LOADER_IMPORT_23___}" />
<!---->
<!-- prettier-ignore -->
<div class="btn white ">
  <a class="u-hover" data-id="tarot-result_back_top" href="/fortune/?from=tarot-result_back_top">
    <span>
      
      <img src="/fortune/images/arrow-link-black.png" width="26" height="9" alt="" />
      
    </span>
    占いTOPへ戻る
    <span>
       
    </span>
  </a>
</div>
</div>

            </div>
          </div>

          
<!---->

<link rel="stylesheet" href="${___HTML_LOADER_IMPORT_25___}" />

<nav class="breadcrumbs">
  <ul>
    
      <li><a href="/">ホーム</a></li>
    
      <li><a href="/fortune/">星座＆タロット占い</a></li>
    
      <li><a href="/fortune/tarot/">タロット占い</a></li>
    
    <li>運命の人とはもう出会っている？</li>
  </ul>
</nav>

        </div>
      </main>
      <!-- /.inner -->
    </div>
    <!-- /#contents -->

    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_26___}" />
<div id="footer-address">
  <!-- 戻るリンク -->
  <div id="pagetop">
    <a href="#"
      ><img
        src="/cmn/img/top_ponta.svg"
        alt="TOPへ戻る"
        width="69"
        height="89"
        loading="lazy"
    /></a>
  </div>
  <div class="footer-address-wrapper">
    <address id="address_top">
      保険取扱代理店：株式会社 ロイヤリティマーケティング<br />
      〒150-0013　東京都渋谷区恵比寿1-18-14 恵比寿ファーストスクエア 7階
    </address>
    <p>
      このホームページは、各保険商品の概要についてご紹介しております。<br />
      補償内容の確認やご契約及びご加入にあたっては、各保険商品のリンク内をご確認ください。
    </p>
    <link rel="stylesheet" href="${___HTML_LOADER_IMPORT_18___}" />
<ul class="sitepolicy-link">
  <li>
    <a href="/about/#insurance_inquiry" data-id="footer_inquiry"
      >お問い合わせ一覧</a
    >
  </li>
  <li>
    <a
      href="/about/solicitation_policy/"
      data-id="footer_solicitation-policy"
      >代理店勧誘方針について</a
    >
  </li>
  <li>
    <a href="/about/" data-id="footer_site-guide"
      >お金のミカタについて</a
    >
  </li>
  <li>
    <a href="/about/sitemap/" data-id="footer_sitemap"
      >サイトマップ</a
    >
  </li>
</ul>

  </div>
</div>
<footer id="FOOTER" class="footer">
  <ul>
    <li>
      <a
        href="https://policy.ponta.jp/c/privacy/index3.htm?from=footer_technology"
        data-id="footer_technology"
        target="_blank"
        rel="noopener"
        >利用技術及び外部送信ポリシー</a
      >
    </li>
    <li>
      <a
        href="https://www.ponta.jp/c/dpc/?from=footer_ponta-app"
        data-id="footer_ponta-app"
        target="_blank"
        rel="noopener"
        >Pontaアプリ</a
      >
    </li>
    <li>
      <a
        href="https://www.loyalty.co.jp/?from=footer_company"
        data-id="footer_company"
        target="_blank"
        rel="noopener"
        >運営会社</a
      >
    </li>
  </ul>
  <p class="copy">©Ponta</p>
</footer>


    <!-- /.container-wrap .rsp -->
  </body>
</html>
`;
// Exports
export default code;